<template>
  <div v-if="!isClose" class="anchor-alert" :class="{ 
    'anchor-alert--top': position === 'top', 
    'anchor-alert--bottom': position === 'bottom', 
    'anchor-alert--closing': transitionClose,
  }">
    <div class="anchor-alert__content">
      <slot></slot>
    </div>

    <span @click="onClose" class="anchor-alert__close">
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.7 12.3C14.1 12.7 14.1 13.3 13.7 13.7C13.5 13.9 13.3 14 13 14C12.7 14 12.5 13.9 12.3 13.7L7 8.4L1.7 13.7C1.5 13.9 1.3 14 1 14C0.7 14 0.5 13.9 0.3 13.7C-0.1 13.3 -0.1 12.7 0.3 12.3L5.6 7L0.3 1.7C-0.1 1.3 -0.1 0.7 0.3 0.3C0.7 -0.1 1.3 -0.1 1.7 0.3L7 5.6L12.3 0.3C12.7 -0.1 13.3 -0.1 13.7 0.3C14.1 0.7 14.1 1.3 13.7 1.7L8.4 7L13.7 12.3Z" fill="white"/>
      </svg>
    </span>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import store from "../../store/store";

export default {
    name: "anchor-verify-email-alert",

    props: {
      position: String,
    },

    data() {

      const shouldOpenAnchorVerifyEmail = Cookies.get("is-closed-anchor-verify-email") ? JSON.parse(Cookies.get("is-closed-anchor-verify-email")) == true : false;

      return {
        isClose: shouldOpenAnchorVerifyEmail,
        transitionClose: false
      }
    },

    watch: {},
	mounted() {
		this.$root.$on('onStartOnboardingDashboard', () => {
			this.isClose = true;
		})
		this.$root.$on('onCloseOnboardingDashboard', () => {
			this.isClose = false;
		})
	},
    methods: {
      onClose() {
        this.transitionClose = true;
        setTimeout(() => {
          this.isClose = true;

        Cookies.set("is-closed-anchor-verify-email", true, {
          expires: new Date((new Date).getTime() + (6 * 60 * 60 * 1000)),
        })
        }, 300)
      }
    },
}
</script>

<style lang="scss">
@import "@sass/vuexy/_variables.scss";

.anchor-alert {
  position: fixed;
  min-height: 50px;
  width: 100%;
  background-color: $primary;
  left: 0;
  z-index: 999999999;
  padding: 15px;
  font-size: 14px;
  font-weight: 400;
  text-align: center;
  color: $white;
  display: flex;
  align-items: center;
  transition: all 300ms ease;

  &--top {
    top: 0;
  }

  &--bottom {
    bottom: 0;
  }

  &--closing {
    transform: translateY(100%);
  }

  .anchor-alert__content {
    margin-left: auto;
  }

  .anchor-alert__close {
    margin-left: auto;
    cursor: pointer;
    line-height: 0;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/Alert/AnchorVerifyEmailAlert.vue